import script from "./CourseModalVideoSettingsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseModalVideoSettingsMenu.vue?vue&type=script&setup=true&lang=js"

import "./CourseModalVideoSettingsMenu.vue?vue&type=style&index=0&id=fc1a1a4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc1a1a4a"]])

export default __exports__